export default __webpack_public_path__ + "static/media/2t.a0153464.jpg";